import { render, staticRenderFns } from "./SecurityDashboard.vue?vue&type=template&id=48cfbbf3&scoped=true&"
import script from "./SecurityDashboard.vue?vue&type=script&lang=js&"
export * from "./SecurityDashboard.vue?vue&type=script&lang=js&"
import style0 from "./SecurityDashboard.vue?vue&type=style&index=0&id=48cfbbf3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48cfbbf3",
  null
  
)

export default component.exports